import { render, staticRenderFns } from "./FreeJobPostingBase.vue?vue&type=template&id=48379af2&scoped=true"
import script from "./FreeJobPostingBase.vue?vue&type=script&lang=js"
export * from "./FreeJobPostingBase.vue?vue&type=script&lang=js"
import style0 from "./FreeJobPostingBase.vue?vue&type=style&index=0&id=48379af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48379af2",
  null
  
)

export default component.exports